import { useCallback } from 'react'
import { SetCompleteDataTy } from '../../../baseComponents/TwinTable/InputTableLayout/types'
import useInputTableFilterData from './useInputTableFilterData'

interface InputTableFilterLogicProps {
    setCompleteData: SetCompleteDataTy
}

const useInputTableFilterFnc = ({ setCompleteData }: InputTableFilterLogicProps) => {
    const { parseTableData } = useInputTableFilterData({ setCompleteData })
    const onChangeOrder = useCallback(() => {

    }, [])

    const onChangeSearchBar = useCallback((value: string) => {
        parseTableData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            return { ...copy, generalSearchbar: value }
        })
    }, [parseTableData])

    const changeSingleField = useCallback((fieldName: string, value: string) => {
        parseTableData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            let myFilters = {
                ...copy,
                singleFieldsSearch: {
                    ...copy.singleFieldsSearch,
                    [fieldName]: value
                }
            }
            if (value === '') {
                delete myFilters.singleFieldsSearch[fieldName]
            }
            return myFilters
        })
    }, [parseTableData])
    return { onChangeSearchBar, changeSingleField, onChangeOrder }
}

export default useInputTableFilterFnc